import { render, staticRenderFns } from "./VkAdds.vue?vue&type=template&id=13820e3a"
import script from "./VkAdds.vue?vue&type=script&lang=js"
export * from "./VkAdds.vue?vue&type=script&lang=js"
import style0 from "./VkAdds.vue?vue&type=style&index=0&id=13820e3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports